import { OrderStates, useDictionary, useOrder } from '@adamlip/okeoke.client';
import { OpenReplayContext } from 'contexts/OpenReplayContext';
import { useContext, useEffect, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { useNavigate } from 'react-router-dom';
import LoadSvg from 'utils/LoadSvg-v3';
import { CircularProgress } from '@nextui-org/react';

function GeneralBackref(props) {
  const { loading, transactionID, errorMessage, orderUUID, success, paymentAgent } = props;

  const { getValue } = useDictionary();
  const navigate = useNavigate();
  const { paymentState, orderNumber, discountPrice, isReady, location, paymentsNeeded, orderState } = useOrder(null, orderUUID);

  const [delay, setDelay] = useState(false);
  const { tracker, trackerInstalled } = useContext(OpenReplayContext);
  useEffect(() => {
    let timer = setTimeout(() => {
      setDelay(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const handlePaymentStart = () => {
    if (paymentState?.paymentInProgress) {
      navigate(paymentState?.paymentUrl);
    } else {
      navigate(`/orderpay/select/${orderUUID}`);
    }
  };

  const goToOrderStates = () => {
    navigate(`/orderview/${orderUUID}`);
    if (tracker?.current && trackerInstalled) {
      tracker?.current?.setMetadata('orderNumber', orderNumber);
    }
  };
  // const transactionID = "0121212"
  // const success = true
  // const paymentAgent = "Offline"
  // const paymentsNeeded = 0
  // const orderState = OrderStates.UNCONFIRMED
  //const orderState = OrderStates.SEEN

  return (
    <div className='hidden-content appear backref-container pb-52'>
      <div className='order-details'>
        <div className='order-status'>
          {(loading || !isReady) && (
            <>
              <div className='loader-container'>
                <CircularProgress color='primary' size='sm' aria-label='aria label' />
              </div>
              <div className='message'>{getValue('app_v2_backref_loading')}</div>
            </>
          )}
          {!loading && isReady && (
            <>
              {!success && (
                <>
                  <LoadSvg name='coloredFail' />
                  <div className='message red'>{getValue('app_v2_backref_failed')}</div>
                  <div className='message-primary'>{getValue('app_v2_backref_paymentRequired')}</div>
                  <div className='message-secondary'>{errorMessage}</div>
                  {paymentAgent === 'Online' && <div className='message-secondary'>{getValue('app_v2_backref_onlinePaymentRequired')}</div>}
                </>
              )}
              {success && (
                <>
                  {orderState > OrderStates.UNCONFIRMED && (
                    <>
                      <LoadSvg name='coloredCheck' />
                      <div className='message green'>{getValue('app_v2_backref_success')}!</div>
                      <div className='message-primary'>{getValue('app_v2_backref_paymentSuccess')}</div>
                      <div className='message-secondary'>{getValue('app_v2_backref_goToOrderState')}</div>
                    </>
                  )}
                  {orderState <= OrderStates.UNCONFIRMED && (
                    <>
                      <LoadSvg name='actionReq' />
                      <div className='message orange'>{getValue('app_v2_backref_actionReq')}!</div>
                      <div className='message-primary'>{getValue('app_v2_backref_paymentRequired')}</div>
                      {paymentAgent === 'Offline' && <div className='message-secondary'>{getValue('app_v2_backref_offlinePaymentRequired')}</div>}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
        <div className='order-data'>
          <div className='order-number'>
            #{orderNumber} {getValue('app_v2_order')}
          </div>
          {transactionID != null && (
            <div className='hidden-content appear order-data-block payment-transaction-id'>
              <div className='label'>{getValue('app_v2_paymentTransactionId')}</div>
              <div className='value'>{transactionID}</div>
            </div>
          )}
          {!paymentState?.paymentInProgress && (
            <>
              <div className='hidden-content appear order-data-block payment-agent'>
                <div className='label'>{getValue('app_v2_paymentAgent')}</div>
                <div className='value'>{paymentAgent}</div>
              </div>
              <div className='hidden-content appear order-data-block location'>
                <div className='label'>{getValue('app_v2_orderLocation')}</div>
                <div className='value'>{location?.name}</div>
              </div>
            </>
          )}
          {paymentState?.paymentInProgress && (
            <div className='hidden-content appear progress'>
              <CircularProgress color='primary' size='lg' aria-label='aria label' />
              <div className='message'>{getValue('app_v2_backref_paymentInProgress')}...</div>
            </div>
          )}
        </div>
        <div className='order-discount-price'>
          <div className='label'>{getValue('app_v2_backref_discountPrice')}</div>
          <div className={`value ${success ? (orderState > OrderStates.UNCONFIRMED ? 'green' : 'orange') : 'red'}`}>
            <NumericFormat value={+discountPrice} decimalSeparator=',' suffix=' Ft' thousandSeparator='.' displayType='text' />
          </div>
        </div>
      </div>
      <div className='action'>
        {!loading && isReady && delay && (
          <>
            {!success && (
              <>
                {(paymentAgent === 'SimplePay' || paymentAgent === 'VivaPay' || paymentAgent === 'BigFish') && (
                  <div className='hidden-content appear btn' onClick={handlePaymentStart}>
                    {getValue('app_v2_backref_goToOnlinePayments')}
                  </div>
                )}
              </>
            )}
            {success && (
              <>
                {orderState > OrderStates.BASKET && (
                  <>
                    <div className='hidden-content appear btn' onClick={goToOrderStates}>
                      {getValue('app_v2_backref_goToOrderStates')}
                    </div>
                  </>
                )}
                {orderState <= OrderStates.UNCONFIRMED && (
                  <>
                    {paymentsNeeded > 0 && (paymentAgent === 'SimplePay' || paymentAgent === 'VivaPay') && !paymentState?.paymentInProgress && (
                      <div className='hidden-content appear btn' onClick={handlePaymentStart}>
                        {getValue('app_v2_backref_goToOnlinePayments')}
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
export default GeneralBackref;
